export default {
  'pages.layouts.userLayout.title':
    'Ant Design adalah spesifikasi desain Web yang paling berpengaruh di Kabupaten Xihu',
  'pages.login.accountLogin.tab': 'Login dengan akun',
  'pages.login.accountLogin.errorMessage':
    'Nama pengguna dan kata sandi salah(admin/ant.design)',
  'pages.login.failure': 'Log masuk gagal, silakan coba lagi!',
  'pages.login.success': 'Login berhasil!',
  'pages.login.username.placeholder': 'nama pengguna: admin atau user',
  'pages.login.username.required': 'Nama pengguna harus diisi!',
  'pages.login.password.placeholder': 'kata sandi: ant.design',
  'pages.login.password.required': 'Kata sandi harus diisi!',
  'pages.login.phoneLogin.tab': 'Login dengan ponsel',
  'pages.login.phoneLogin.errorMessage': 'Kesalahan kode verifikasi',
  'pages.login.phoneNumber.placeholder': 'masukkan nomor telepon',
  'pages.login.phoneNumber.required': 'Nomor ponsel harus diisi!',
  'pages.login.phoneNumber.invalid': 'Nomor ponsel tidak valid!',
  'pages.login.captcha.placeholder': 'kode verifikasi',
  'pages.login.captcha.required': 'Kode verifikasi diperlukan!',
  'pages.login.phoneLogin.getVerificationCode': 'Dapatkan kode',
  'pages.getCaptchaSecondText': 'detik tersisa',
  'pages.login.rememberMe': 'Ingat saya',
  'pages.login.forgotPassword': 'Lupa Kata Sandi?',
  'pages.login.submit': 'Masuk',
  'pages.login.loginWith': 'Masuk dengan :',
  'pages.login.registerAccount': 'Daftar Akun',
  'pages.welcome.link': 'Selamat datang',
  'pages.welcome.alertMessage':
    'Komponen heavy-duty yang lebih cepat dan lebih kuat telah dirilis.',
  'pages.404.subTitle': 'Maaf, halaman yang Anda kunjungi tidak ada. ',
  'pages.404.buttonText': 'Kembali ke halaman utama',
  'pages.admin.subPage.title': 'Halaman ini hanya dapat dilihat oleh admin',
  'pages.admin.subPage.alertMessage':
    'umi ui telah dirilis, silahkan gunakan npm run ui untuk memulai pengalaman.',
  'pages.searchTable.createForm.newRule': 'Aturan baru',
  'pages.searchTable.updateForm.ruleConfig': 'Konfigurasi aturan',
  'pages.searchTable.updateForm.basicConfig': 'Informasi dasar',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nama aturan',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Harap masukkan nama aturan!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Deskripsi aturan',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Harap masukkan setidaknya lima karakter',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Harap masukkan deskripsi aturan setidaknya lima karakter!',
  'pages.searchTable.updateForm.ruleProps.title': 'Properti aturan',
  'pages.searchTable.updateForm.object': 'Objek pemantauan',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Template aturan',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Jenis aturan',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Periode penjadwalan',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Waktu mulai',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Pilih waktu mulai!',
  'pages.searchTable.titleDesc': 'deskripsi',
  'pages.searchTable.ruleName': 'Nama aturan wajib diisi',
  'pages.searchTable.titleCallNo': 'Jumlah panggilan',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'menyala',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Waktu terjadwal',
  'pages.searchTable.exception': 'Harap masukkan alasan pengecualian!',
  'pages.searchTable.titleOption': 'Pengoperasian',
  'pages.searchTable.config': 'Konfigurasi',
  'pages.searchTable.subscribeAlert': 'Berlangganan notifikasi',
  'pages.searchTable.title': 'Formulir pertanyaan',
  'pages.searchTable.new': 'Baru',
  'pages.searchTable.chosen': 'Terpilih',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Jumlah total panggilan layanan',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Penghapusan batch',
  'pages.searchTable.batchApproval': 'Persetujuan batch',
  
  // Order Statistics Page
  'pages.orders.statistics.title': 'Statistik Pesanan',
  'pages.orders.statistics.dateRange': 'Rentang Tanggal',
  'pages.orders.statistics.last7Days': '7 Hari Terakhir',
  'pages.orders.statistics.last30Days': '30 Hari Terakhir',
  'pages.orders.statistics.last90Days': '90 Hari Terakhir',
  'pages.orders.statistics.totalOrders': 'Total Pesanan',
  'pages.orders.statistics.totalSales': 'Total Penjualan',
  'pages.orders.statistics.refundCount': 'Jumlah Produk Dikembalikan',
  'pages.orders.statistics.refundAmount': 'Jumlah Pengembalian',
  'pages.orders.statistics.trendChart': 'Grafik Tren Bisnis',
  'pages.orders.statistics.dailyStats': 'Statistik Harian',
  'pages.orders.statistics.chart.orders': 'Pesanan',
  'pages.orders.statistics.chart.revenue': 'Pendapatan',
  'pages.orders.statistics.chart.refunds': 'Pengembalian',
  'pages.orders.statistics.table.date': 'Tanggal',
  'pages.orders.statistics.table.orderCount': 'Jumlah Pesanan',
  'pages.orders.statistics.table.revenue': 'Pendapatan',
  'pages.orders.statistics.table.refundCount': 'Jumlah Pengembalian',
  'pages.orders.statistics.table.refundAmount': 'Jumlah Pengembalian',
  'pages.orders.statistics.table.total': 'Total {total} item',

  // Pengaturan Rebate Live
  'pages.live.rebate.title': 'Pengaturan Rebate Live',
  'pages.live.rebate.liveTeamName': 'Nama Tim Live',
  'pages.live.rebate.memberId': 'ID Anggota',
  'pages.live.rebate.sellerId': 'ID Penjual',
  'pages.live.rebate.sellerPercent': 'Penjual %',
  'pages.live.rebate.companyPercent': 'Perusahaan %',
  'pages.live.rebate.teamPercent': 'Tim %',
  'pages.live.rebate.teamRebatePercent': 'Rebate Tim %',
  'pages.live.rebate.settingTimeAdmin': 'Waktu Pengaturan / Admin',
  'pages.live.rebate.actions': 'Aksi',
  'pages.live.rebate.setting': 'Pengaturan',
  'pages.live.rebate.detail': 'Detail',
  'pages.live.rebate.delete': 'Hapus',
  'pages.live.rebate.addRebate': 'Tambah Rebate',
  'pages.live.rebate.batchUpdate': 'Perbarui Massal',
  'pages.live.rebate.selectFirst': 'Silakan pilih item terlebih dahulu',
  'pages.live.rebate.addSuccess': 'Rebate berhasil ditambahkan',
  'pages.live.rebate.addFailed': 'Gagal menambahkan rebate',
  'pages.live.rebate.updateSuccess': 'Rebate berhasil diperbarui',
  'pages.live.rebate.updateFailed': 'Gagal memperbarui rebate',
  'pages.live.rebate.deleteSuccess': 'Rebate berhasil dihapus',
  'pages.live.rebate.deleteFailed': 'Gagal menghapus rebate',
  'pages.live.rebate.deleteConfirm': 'Hapus Rebate',
  'pages.live.rebate.deleteContent': 'Apakah Anda yakin ingin menghapus pengaturan rebate ini?',
  'pages.live.rebate.addModalTitle': 'Tambah Pengaturan Rebate',
  'pages.live.rebate.editModalTitle': 'Edit Pengaturan Rebate',
  'pages.live.rebate.liveTeamNameRequired': 'Silakan masukkan nama tim live',
  'pages.live.rebate.memberIdRequired': 'Silakan masukkan ID anggota',
  'pages.live.rebate.sellerIdRequired': 'Silakan masukkan ID penjual',
  'pages.live.rebate.sellerPercentRequired': 'Silakan masukkan persentase penjual',
  'pages.live.rebate.companyPercentRequired': 'Silakan masukkan persentase perusahaan',
  'pages.live.rebate.teamPercentRequired': 'Silakan masukkan persentase tim',
  'pages.live.rebate.teamRebatePercentRequired': 'Silakan masukkan persentase rebate tim',
  'pages.live.rebate.loadFailed': 'Gagal memuat pengaturan rebate',
  'pages.live.rebate.selectAtLeastTwo': 'Silakan pilih minimal 2 item',
  'pages.live.rebate.batchSetting': 'Pengaturan Massal',
  'pages.live.rebate.batchUpdateTitle': 'Perbarui Persentase Massal',
  'pages.live.rebate.selectedItems': 'item dipilih',
  'pages.live.rebate.applySetting': 'Terapkan Pengaturan',
  'pages.live.rebate.cancel': 'Batal',
  'pages.live.rebate.batchUpdateSuccess': 'Pembaruan massal berhasil diselesaikan',
  'pages.live.rebate.batchUpdateFailed': 'Pembaruan massal gagal',
  'pages.live.rebate.searchLabel': 'Cari',
  'pages.live.rebate.searchPlaceholder': 'Cari berdasarkan nama tim live, ID penjual, atau ID anggota',
  'pages.live.rebate.search': 'Cari',
  'pages.live.rebate.reset': 'Reset',
  'pages.live.rebate.teamLead': 'Ketua Tim',
  'pages.live.rebate.teamLeadId': 'ID Ketua Tim',
  'pages.live.rebate.teamLeadIdRequired': 'Silakan masukkan ID ketua tim',
  'pages.live.rebate.teamInternalSelfPercent': 'Internal Tim Sendiri %',
  'pages.live.rebate.teamInternalSelfPercentRequired': 'Silakan masukkan persentase internal tim sendiri',
  'pages.live.rebate.teamInternalUplinePercent': 'Internal Tim Atasan %',
  'pages.live.rebate.teamRebate': 'Rebat Tim',
  'pages.live.rebate.memberSettings': 'Pengaturan Anggota',
  'pages.live.rebate.memberSettingsTitle': 'Pengaturan rebat per penjual',
  'pages.live.rebate.memberSettingsHint': 'Atur persentase rebat penjual individual. Nilai yang disimpan menggantikan pengaturan tim untuk penjual tersebut; penjual "Belum diatur" tetap menggunakan pengaturan tim.',
  'pages.live.rebate.memberSource': 'Sumber',
  'pages.live.rebate.memberSourceTeamCopy': 'Disalin dari tim',
  'pages.live.rebate.memberSourceAdmin': 'Diatur individual',
  'pages.live.rebate.memberSourceNone': 'Belum diatur (pengaturan tim)',
  'pages.live.rebate.memberSourceTeamConfig': 'Pengaturan tim',
  'pages.live.rebate.memberSelfPercent': '% sendiri',
  'pages.live.rebate.memberSave': 'Simpan',
  'pages.live.rebate.memberSaveSuccess': 'Pengaturan rebat penjual disimpan',
  'pages.live.rebate.memberSaveFailed': 'Gagal menyimpan pengaturan rebat penjual',
  'pages.live.rebate.memberLoadFailed': 'Gagal memuat anggota tim',
  'pages.live.rebate.marginSumError': 'Penjual + Perusahaan + Tim % harus berjumlah 100',
  'pages.live.rebate.teamLeadTag': 'Ketua tim',
  'pages.live.rebate.teamInternalUplinePercentRequired': 'Silakan masukkan persentase internal tim atasan',
  'pages.live.rebate.configuredAt': 'Waktu Konfigurasi',
  'pages.live.rebate.configuredAtRequired': 'Silakan pilih waktu konfigurasi',
  'pages.live.sellers.userId': 'ID Pengguna',
  'pages.live.sellers.sellerId': 'ID Penjual',
  'pages.live.sellers.name': 'Nama',
  'pages.live.sellers.recommender': 'Referral',
  'pages.live.sellers.team': 'Anggota Tim',
  'pages.live.sellers.follower': 'Pengikut',
  'pages.live.sellers.salesAmount': 'Jumlah Penjualan',
  'pages.live.sellers.salesCount': 'Jumlah Transaksi',
  'pages.live.sellers.rebate': 'Akumulasi Rebate',
  'pages.live.sellers.refundAmount': 'Jumlah Refund',
  'pages.live.sellers.rebateDeduction': 'Potongan Rebate',
  'pages.live.sellers.liveStatus': 'Status Live',
  'pages.live.sellers.liveStatus.live': 'Live',
  'pages.live.sellers.liveStatus.idle': 'Idle',
  'pages.live.sellers.homepage': 'Beranda',
  'pages.live.sellers.homepageLink': 'Tautan',
  'pages.live.sellers.actions': 'Aksi',
  'pages.live.rebate.levelDetailTitle': 'Daftar Tim Live',
  'pages.live.rebate.levelDetail.column.teamName': 'Nama Tim',
  'pages.live.rebate.levelDetail.column.depth': 'Level',
  'pages.live.rebate.levelDetail.column.userUniqueId': 'ID Penjual',
  'pages.live.rebate.levelDetail.column.userId': 'ID Pengguna',
  'pages.live.rebate.levelDetail.column.userName': 'Nama Pengguna',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': 'Jumlah Bawahan',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': 'Jumlah Penjualan (KRW)',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': 'Jumlah Margin (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': 'Kuantitas Penjualan',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': 'Jumlah Pengembalian Dana (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': 'Kuantitas Pengembalian Dana',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': 'Rebate Tim Terakumulasi (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': 'Rebate Tim Dipotong (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': 'Rebate Tim Setelah Refund (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': 'Perusahaan Terakumulasi (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': 'Perusahaan Dipotong (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': 'Perusahaan Setelah Refund (KRW)',
  'pages.live.rebate.levelDetail.column.action': 'Aksi',
  'pages.live.rebate.levelDetail.searchLabel': 'Cari:',
  'pages.live.rebate.levelDetail.searchPlaceholder': 'Cari berdasarkan ID penjual, ID pengguna, atau nama pengguna...',
  'pages.live.rebate.levelDetail.searchButton': 'Cari',
  'pages.live.rebate.levelDetail.resetButton': 'Reset',
  'pages.live.rebate.levelDetail.reloadButton': 'Muat Ulang',
  'pages.live.rebate.levelDetail.detailButton': 'Detail',
  'pages.live.rebate.levelDetail.loadError': 'Gagal memuat data detail rebate live',
  'pages.live.rebate.levelDetail.level1': 'Level 1',
  'pages.live.rebate.levelDetail.level2': 'Level 2',
  'pages.live.rebate.levelDetail.level3': 'Level 3',
  'pages.live.rebate.levelDetail.level4': 'Level 4',
};
